import { HotKeyAction, HotKeyActionId } from './types';

export const FILE_DIALOG_HOT_KEYS: HotKeyAction[] = [
  {
    id: HotKeyActionId.Rename,
    key: 'f2',
    label: '(F2)',
    description: 'Rename',
    group: 'File Operations',
    showInTooltip: true,
  },
  {
    id: HotKeyActionId.MoveToIncoming,
    key: 'Shift+Ctrl+KeyI',
    label: '(⇧⌃I)',
    description: 'Move to Incoming',
    group: 'File Operations',
    showInTooltip: true,
  },
  {
    id: HotKeyActionId.MoveToOutgoing,
    key: 'Shift+Ctrl+KeyO',
    label: '(⇧⌃O)',
    description: 'Move to Outgoing',
    group: 'File Operations',
    showInTooltip: true,
  },
  {
    id: HotKeyActionId.ArrowLeft,
    key: 'ArrowLeft',
    label: '(←)',
    description: 'Left arrow',
    group: 'File Operations',
    showInTooltip: false,
  },
  {
    id: HotKeyActionId.ArrowRight,
    key: 'ArrowRight',
    label: '(→)',
    description: 'Right arrow',
    group: 'File Operations',
    showInTooltip: false,
  },
];
export const SEARCHED_FILES_HOT_KEYS: HotKeyAction[] = [
  {
    id: HotKeyActionId.Rename,
    key: 'f2',
    label: '(F2)',
    description: 'Rename file',
    group: 'File Operations',
    showInTooltip: true,
  },
];

export const FILES_TABLE_HOT_KEYS: HotKeyAction[] = [
  {
    id: HotKeyActionId.MoveFiles,
    key: 'Shift+Ctrl+KeyM',
    label: '(⇧⌃M)',
    description: 'Move selected files',
    group: 'File Operations',
    showInTooltip: true,
  },
];
